<div class="text-center" style="padding: 15px;">
  <div class="row">
    <div class="col-lg-6" style="padding: 0px 10px;display: flex;justify-content: center;align-items: center;">
      <p>{{data.details}}</p>
    </div>
    <div class="col-lg-6 blog-item">
      <div class="blog-top">
        <a *ngIf="data.image != null;else Blogimage"><img [src]="data.image | SafeUrlPipe" alt="Blog" > </a>
        <ng-template #Blogimage><a><img src="assets/img/DefaultImage.png" alt="Blog"  height="250px" width="350px"></a></ng-template>
    </div>
    </div>
  </div>
  <div mat-dialog-content style="margin: 30px">
    <h3>{{data.title}}</h3>
  </div>
  <div class="text-center">
    <button class="btn btn-primary"  (click)="onNoClick()">{{ 'COMMON.OK' | translate }}</button>
  </div>
</div>

